// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__19gjm","list":"PatternAutocomplete_list__28v4j"};